import { supportQueryKeys as e } from "./supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/useHelpCategoriesQuery.ts
var r = (r) => t({
	queryKey: e.categories(r),
	queryFn: () => n.listHelpCategories({ user_type: r })
});
//#endregion
export { r as useHelpCategoriesQuery };
